import { RiAdminLine, RiUserLine, RiUserSettingsLine, RiUserStarLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import TooltipWrapper from '../TooltipWrapper/TooltipWrapper';
import { Profile } from 'types/Profile';
import QuestionIcon from 'components/Icon/icons/QuestionIcon';

interface IRole {
  userRole?: string | null;
  small?: boolean;
  useTooltip?: boolean;
}

function Role({ userRole, small = false, useTooltip = false }: IRole) {
  const { t } = useTranslation();
  if (!userRole) {
    return null;
  }

  let style = 'bg-slate-500';
  let logoStyle = 'w-5 h-5';
  let text = '?';

  let Icon = QuestionIcon;
  let noText = false;
  let baseStyle = small ? 'py-1 px-2 h-6 text-[0.8rem]' : 'py-1.5 px-4 text-[1rem]';

  if (userRole === 'Authenticated') {
    style = 'bg-violet-400';
    text = t('roles.Authenticated');
    Icon = RiUserLine;
  }

  if (userRole === 'Mediator') {
    style = 'bg-blue-300';
    text = t('roles.Mediator');
    Icon = RiUserStarLine;
  }

  if (userRole === 'Admin') {
    style = 'bg-blue-400';
    text = t('roles.Administrateur');
    Icon = RiUserSettingsLine;
  }

  if (userRole === 'SuperAdmin') {
    style = 'bg-blue-500';
    text = t('roles.SuperAdmin');
    Icon = RiAdminLine;
  }

  return useTooltip ? (
    <TooltipWrapper
      className="mr-1 my-1"
      content={
        <span>
          {i18n.exists(`status.${userRole}Tooltip`) ? t(`status.${userRole}Tooltip`) : text}
        </span>
      }
      place="top"
    >
      <div
        className={`flex items-center gap-1 font-normal leading-0 text-center text-white rounded-full ${baseStyle} ${style} shrink-0`}
      >
        {Icon && <Icon title={text} className={`${logoStyle}`} />}
        {!noText ? ` ${text}` : null}
      </div>
    </TooltipWrapper>
  ) : (
    <div
      className={`flex items-center gap-1 font-normal leading-0 text-center text-white rounded-full ${baseStyle} ${style} shrink-0`}
    >
      {Icon && <Icon title={text} className={`${logoStyle}`} />}
      {!noText ? ` ${text}` : null}
    </div>
  );
}

export default Role;
